<template>
	<div class="title-h3">
		<div>
			<span class="main-title cur-poi" @click="$nav.back()">{{ $t('投资组合') }}</span>
			<span class="team-grade">
				{{ $t('当前团队等级') }}
				<span class="num">V0</span>
				<span class="rule ">{{ $t('等级规则') }}</span>
			</span>
		</div>
		<div class="right-con cur-poi" @click="$nav.go('/pc/portfolioOrder')">
			<img src="@/assets/img-pc/49.d2aeee3b.svg">
			<span>{{ $t('投资订单') }}</span>
		</div>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.title-h3 {
	height: 80px;
	line-height: 80px;
	margin: 0 auto;
	font-size: 24px;
	border-bottom: 1px solid #31323f;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.team-grade {
		font-size: 14px;
		margin-left: 30px;

		.num {
			margin-left: 20px;
			color: #f7931a;
		}

		.rule {
			color: #00f0ff;
			margin-left: 10px;
		}
	}

	.right-con {
		font-size: 16px;
		color: #fff;
		display: flex;
		align-items: center;

		img {
			margin-right: 5px;
		}
	}
}
</style>